module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"name":"Template name","saveAsTemplate":"Save as a template","save":"Save","name.error.required":"This field is required to save your template","name.error.unique":"This template name is already taken, please choose a unique name.","server.error":"There was an error saving your template."}}')
  delete Component.options._Ctor
}
